import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-previw",
  "use": "icon-previw-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-previw\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M11.1,8h0A.1.1,0,0,0,11,8.1v2.8a.1.1,0,0,0,.06.09.11.11,0,0,0,.11,0l2.38-1.4a.09.09,0,0,0,0-.16L11.17,8a.11.11,0,0,0-.11,0Zm.9,7a1,1,0,1,0,1,1A1,1,0,0,0,12,15ZM16,5a1,1,0,0,1,1,1V18a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V6A1,1,0,0,1,8,5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol